import AvailablePassengerClassesGroupType
    from "@CheckOrder/features/classPicker/types/AvailablePassengerClassesGroup.type";

export default function findDefaultPassengerClass(extendedAvailablePassengerClassesGroups: AvailablePassengerClassesGroupType[]) {
    let passengerClassIndex = -1;

    const passengerClassesGroupIndex = extendedAvailablePassengerClassesGroups.findIndex(({availablePassengerClasses}) => {
        passengerClassIndex = availablePassengerClasses.findIndex((passengerClass) => (
            passengerClass.isDefault
        ))

        return passengerClassIndex !== -1;
    })

    return extendedAvailablePassengerClassesGroups[passengerClassesGroupIndex]?.availablePassengerClasses[passengerClassIndex]
}